import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const NotesContainer = styled(FlexContainer)`
  width: 100%;
`;

export const NoteTextContainer = styled.div`
  padding: 0;
  font-size: 16px;
  color: #666;
`;

export const Note = styled.div`
  margin: 0;
`;

export const NoteTitle = styled.span`
  color: ${COLOR.BLACK};
  display: inline-block;

  ${TYPOGRAPHY.BOLD};
`;

export const NoteText = styled.span``;

export const NoteSpan = styled.span`
  padding: 0;
  font-size: 16px;
  color: #666;
`;
